"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinComponentSchema = void 0;
/* eslint-disable @typescript-eslint/no-empty-interface */
const zod_1 = require("zod");
const answer_area_pin_component_1 = require("./answer-area-pin-component");
const hotspot_pin_component_1 = require("./hotspot-pin-component");
const image_pin_component_1 = require("./image-pin-component");
const line_pin_component_1 = require("./line-pin-component");
const shape_pin_component_1 = require("./shape-pin-component");
const spinner_pin_component_1 = require("./spinner-pin-component");
const text_pin_component_1 = require("./text-pin-component");
const uneditable_shape_pin_component_1 = require("./uneditable-shape-pin-component");
const video_pin_component_1 = require("./video-pin-component");
exports.PinComponentSchema = zod_1.z.discriminatedUnion('type', [
    hotspot_pin_component_1.HotspotPinComponentSchema,
    image_pin_component_1.ImagePinComponentSchema,
    line_pin_component_1.LinePinComponentSchema,
    shape_pin_component_1.ShapePinComponentSchema,
    text_pin_component_1.TextPinComponentSchema,
    answer_area_pin_component_1.AnswerAreaPinComponentSchema,
    uneditable_shape_pin_component_1.UneditableShapePinComponentSchema,
    video_pin_component_1.VideoPinComponentSchema,
    spinner_pin_component_1.SpinnerPinComponentSchema,
]);
//# sourceMappingURL=pin-component.js.map